<template>
    <div class="modal is-active">
      <div class="modal-background" @click="this.$store.state.modalCrearMapaOnLine = false"></div>
      <div class="mr-6">
        <div class="modal-card">
          <header class="columns is-mobile modal-card-head BGBendicion m-0">
            <p class="modal-card-title has-text-weight-bold" >{{ textoInterfaz.titulo }}</p>
            <i class="fa-2x fas fa-times-circle has-text-danger cruzeta" @click="this.$store.state.modalCrearMapaOnLine = false"></i>
          </header>

          <section class="modal-card-body hero is-large py-4">

            <SignedOut>
              <p class="subtitle has-text-centered">{{ textoInterfaz.textoError }}</p>
              <SignInButton class="button" />
            </SignedOut>

            <SignedIn>
              <div class="has-text-centered" v-if="this.beforeCreateMap">
                <h2 class="subtitle mb-0">{{ textoInterfaz.confirm }}</h2>
                <button @click="postNewMapInPlay()" class="button my-3 is-success">{{ textoInterfaz.botones.create }}</button>
              </div>

              <div class="has-text-centered" v-else>
                <h2 class="subtitle">{{ textoInterfaz.textLogged }}</h2>
                <b-field >
                    <b-input placeholder="ej: 1234-1234-1234" type="search" icon="magnify" v-model="barCode"> </b-input>
                    <p class="control">
                        <b-button type="is-primary" label="Copiar" @click="copyCode()" />
                    </p>
                </b-field>
              </div>
            </SignedIn>
          </section>

          <footer>
            <div class="field has-addons columns is-mobile is-gapless">

              <p class="control column ">
                <button @click="(this.$store.state.modalCrearMapaOnLine = false)" class="button is-link is-fullwidth">
                  <p>{{ textoInterfaz.botones.cerrar }}</p>
                </button>
              </p>
            </div>
          </footer>

        </div>
      </div>
  </div>
</template>
  
<script>
  import { apiService } from '@/services/api.js';
  // importamos clear para la gestion de usuarios
  import { SignedIn, SignedOut, SignInButton, useUser } from '@clerk/vue'

  export default {
    name:"EstadoBendicion",
    components: {
      SignedIn,
      SignedOut,
      SignInButton
    },
    // Aquí añadimos setup() para usar useUser()
    setup() {
      const { user } = useUser()
      // Exponemos user
      return { user }
    },
    data(){
      return{
        beforeCreateMap: true,
        textoInterfaz:{
          titulo: "",
          textoError: "",
          confirm:"",
          textLogged: "",
          botones: {
            create: "",
            cerrar: ""
          },
        },
        mapFound: null,
        // variable para capturar la id nuevo mapa creado
        barCode: ""
        }
        
    },
    methods:{
      rellenarTextoSegunIdioma() {
        if (this.$store.state.lenguaje == 'español') {
          this.textoInterfaz.titulo = "Crear Partida";
          this.textoInterfaz.textoError = "Para crear una partida debes estar Logueado a la app";
          this.textoInterfaz.confirm = "Recuerda que al crear la partida esta quedará registrada en nuestra base de datos junto con tu usuario, si vemos anomalías como creación de múltiples mapas se estudiará el caso y se tomarán medidas sancionadoras. ¡Gracias y disfruta!";
          this.textoInterfaz.textLogged = "Copia este código y pásaselo a tus compañeros de mesa para unirse a la misma partida.";

          this.textoInterfaz.botones.create = "Crear mapa";
          this.textoInterfaz.botones.cerrar = "Cerrar";
        } else if (this.$store.state.lenguaje == 'ingles') {
          this.textoInterfaz.titulo = "Create Game";
          this.textoInterfaz.textoError = "To create a game you must be logged into the app.";
          this.textoInterfaz.confirm = "Remember that when you create a game, it will be recorded in our database along with your user account. If we detect any anomalies—such as the creation of multiple maps—we will review the case and take appropriate sanctioning measures. Thank you, and enjoy!";
          this.textoInterfaz.textLogged = "Copy this code and share it with your tablemates so they can join the same game.";

          this.textoInterfaz.botones.create = "Create map";
          this.textoInterfaz.botones.cerrar = "Close";
        }
      },

      async postNewMapInPlay(){
        try {
          const idMap = this.$store.state.datosMapa.idMap
          const IDUserHost = this.user.id

          const postNewMap = await apiService.postNewMapInPlay(idMap, IDUserHost);
          // añadir el mapa que venga al store para jugarlo
          this.$store.state.datosMapa = await postNewMap
          // volcamos el código para que aparezca en el input
          this.barCode = postNewMap.id
          this.$store.state.datosMapa.id = postNewMap.id
          // meter en el input la id del mapa para copiarlo y pasarlo a otras personas
          // console.log(postNewMap)
          this.beforeCreateMap = false
          this.$buefy.toast.open({
            message: this.$store.state.lenguaje === 'español' ? 'Mapa OnLine creado!' : 'Online map created!',
            type: 'is-success',
            duration: 3000
          });
        } catch (error) {
          console.error("❌ postNewMapInPlay(.vue) - Error al crear el nuevo mapa:", error);
        }
      },
      async copyCode(){
        if (!this.barCode) return alert('Nada que copiar');

        try {
          await navigator.clipboard.writeText(this.barCode);
          this.$buefy.toast.open({
            message: this.$store.state.lenguaje === "español" ? "Código copiado 😊" : "Code copied 😊",
            type: 'is-success',
            duration: 2000,
          });
        } catch (error) {
          this.$buefy.toast.open({
            message: this.$store.state.lenguaje === "español" ? "Error al copiar 😢" : "Copy failed 😢",
            type: 'is-danger',
            duration: 2000,
          });
        }
      }
    },
    mounted(){
      this.rellenarTextoSegunIdioma();
    }
  }
</script>
<style>
  .BGBendicion{
    background-image: url(@/assets/img/Estados/Bendicion.jpg);
    background-position: center;
    background-size: cover;
  }
</style>